<template>
  <ReleasePatient />
</template>

<script>
import ReleasePatient from './releasePatient.vue'

export default {
  name: 'ReleasePatientIndex',
  components: {
    ReleasePatient,
  },
}
</script> 